<template>
  <div
    v-if="isLoading"
    class="w-full h-screen flex items-center justify-center container"
  >
    <dp-loader stroke-width="1.5" class="dp-loader--custom"></dp-loader>
    <img
      src="../assets/images/logo-circled.svg"
      class="w-10 h-10 absolute svg"
      alt=""
    />
  </div>
</template>

<script>
import { DATA_DECRYPTER } from "../utils";
import { userService } from "../services";
export default {
  name: "Auth",
  data() {
    return {
      isLoading: false
    };
  },
  created() {
    if (
      this.$route.query.name != null &&
      this.$route.query.cc != null &&
      this.$route.query.startdate != null &&
      this.$route.query.enddate != null
    ) {
      this.$store.dispatch("addLinkquaryccActions", this.$route.query.cc);
      this.$store.dispatch("addLinkquarynameActions", this.$route.query.name);
      this.$store.dispatch(
        "addLinkStartDateActions",
        this.$route.query.startdate
      );
      this.$store.dispatch("addLinkEndDateActions", this.$route.query.enddate);
    }
    this.isLoading = true;
    const CRYPTO_PASSWORD = "digitasticTeam";
    const token = DATA_DECRYPTER(this.$route.query.key, CRYPTO_PASSWORD);
    const accessToken = DATA_DECRYPTER(
      this.$route.query.accessKey,
      CRYPTO_PASSWORD
    );
    const secretKey = DATA_DECRYPTER(
      this.$route.query.secretKey,
      CRYPTO_PASSWORD
    );
    this.setTokenToStorage({ token, accessToken, secretKey });
    setTimeout(() => this.validateUserSessionGetDetail(), 2000);
  },
  methods: {
    setTokenToStorage(tokens) {
      this.$store.commit("SET_TOKENS", tokens);
      this.$store.commit("SET_CURRENT_USER", true);
    },
    validateUserSessionGetDetail() {
      userService
        .fetchUserDetail()
        .then(userDetail => {
          this.$store.commit("SET_USER_DETAIL", userDetail);
          this.isLoading = false;
          this.$router.push({ name: "Report", params: { filter: "" } });
        })
        .catch(() => {
          window.localStorage.clear();
          this.$store.commit("SET_USER_DETAIL", null);
          this.isLoading = false;
          this.$router.push({ name: "Login" });
        });
    }
  }
};
</script>

<style lang="scss">
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
}
.svg {
  width: 2.5rem !important;
  height: 2.5rem !important;
  position: absolute;
}

.dp-loader--custom {
  width: 4rem !important;
  height: 4rem !important;
}

.dp-loader--custom > svg {
  width: 4rem !important;
  height: 4rem !important;
}
</style>
